
import {
  defineComponent,
  computed,
  PropType,
  watch,
  onMounted,
} from 'vue';
import Cookies from 'js-cookie';
import { useRouter, useRoute } from 'vue-router';
import { MAIN_NAV_ITEMS, NavItem } from '@/constants/navigation';
import { Location } from '@/constants/types';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'MainMenu',
  props: {
    navType: {
      type: String as PropType<string>,
      default: 'basic',
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();

    const store = useStore();

    const navItems = computed(() => {
      switch (props.navType) {
        case 'main':
          return MAIN_NAV_ITEMS(router);
        default:
          return MAIN_NAV_ITEMS(router);
      }
    });

    // get locations from store
    const locations = computed(() => store.getters.getLocations);
    const currentUser = computed(() => store.getters.getCurrentUser);
    const currentLocation = computed(() => store.getters.getCurrentLocation);

    const selectedLocationId = computed({
      get: () => (currentLocation.value ? currentLocation.value.id : Cookies.get('currentLocation') || ''),
      set: (id: string) => {
        const location = locations.value.find((loc: Location) => loc.id === id);
        if (location) {
          store.dispatch('updateCurrentLocation', location);
          // Cookies.set('currentLocation', location.id, { expires: 7 });
        }
      },
    });

    // Issue is with this code... for some reason it stalls out the app / menu
    watch(currentLocation, (newValue) => {
      if (newValue) {
        Cookies.set('currentLocation', newValue.id, { expires: 7 });
      }
    }, { immediate: true });

    onMounted(() => {
      const locationId = Cookies.get('currentLocation');
      if (locationId) {
        store.dispatch('setCurrentLocationById', locationId);
      }
    });

    const filteredNavItems = computed(() => navItems.value.filter((item) => (item.condition ? item.condition() : true)));

    const handleClick = (item: NavItem) => {
      if (item.action) {
        item.action();
      }
    };

    const routeClass = (item: NavItem) => {
      if (route.name && item.routeNames && item.routeNames?.includes(route.name.toString())) {
        return 'router-link router-link-active';
      }

      return 'router-link';
    };

    return {
      navItems,
      filteredNavItems,
      currentUser,
      locations,
      currentLocation,
      selectedLocationId,
      handleClick,
      routeClass,
    };
  },
});
